"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = bindOptionalNode;

var _bindnode = _interopRequireDefault(require("./bindnode"));

var _apply = _interopRequireDefault(require("./_helpers/apply"));

// TODO: Adds a binding, not throwing an error when a node is missing
function bindOptionalNode() {
  // this hack allows to keep bindOptionalNode as compact as possible
  // and doesn't require to flip args and support all bindNode variations
  _bindnode["default"].temporaryOptionalFlag = true;
  return (0, _apply["default"])(_bindnode["default"], this, arguments);
}
//# sourceMappingURL=bindoptionalnode.js.map